import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFeaturedMovies } from '@/utils/movies';

const featured = getFeaturedMovies();

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % featured.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, []);

  if (featured.length === 0) return null;
  const movie = featured[index];

  const go = (next: number) => setIndex((next + featured.length) % featured.length);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[460px] w-full md:h-[600px]">
        {featured.map((item, i) => (
          <div
            key={item.id}
            className={`absolute inset-0 transition-opacity duration-700 ${i === index ? 'opacity-100' : 'opacity-0'}`}
          >
            <img
              src={item.backdrop}
              alt={`${item.title} 剧照`}
              title={`${item.title} - 电影在线观看与剧情介绍`}
              className={`h-full w-full object-top ${i === index ? 'anim-slow-zoom' : ''}`}
            />
          </div>
        ))}

        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-background-50/30"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/55 to-transparent"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
            <div key={movie.id} className="max-w-2xl anim-fade-up">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-700">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500 anim-pulse-soft"></span>
                {movie.status}
              </span>
              <h1 className="mt-4 text-3xl font-extrabold leading-tight text-foreground-950 md:text-5xl">
                {movie.title}
              </h1>
              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-foreground-700">
                <span className="flex items-center gap-1 font-semibold text-secondary-900">
                  <i className="ri-star-fill text-secondary-600"></i>
                  {movie.rating.toFixed(1)}
                </span>
                <span>{movie.year}</span>
                <span className="hidden sm:inline">{movie.region}</span>
                <span className="hidden sm:inline">{movie.genres.join(' / ')}</span>
              </div>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-700 line-clamp-2 md:text-base">
                {movie.tagline}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${movie.id}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-accent-600 dark:text-foreground-950 cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  立即观看
                </Link>
                <Link
                  to={`/category?genre=${encodeURIComponent(movie.genres[0])}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100/70 px-5 py-2.5 text-sm font-medium text-foreground-900 backdrop-blur transition hover:border-accent-400 hover:text-accent-700 cursor-pointer"
                >
                  <i className="ri-bookmark-3-line"></i>
                  更多同类
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一部"
          onClick={() => go(index - 1)}
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-300 bg-background-50/70 text-foreground-900 backdrop-blur transition hover:bg-background-100 md:flex cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一部"
          onClick={() => go(index + 1)}
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-300 bg-background-50/70 text-foreground-900 backdrop-blur transition hover:bg-background-100 md:flex cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>

        <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {featured.map((item, i) => (
            <button
              key={item.id}
              type="button"
              aria-label={`切换到 ${item.title}`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all cursor-pointer ${
                i === index ? 'w-8 bg-accent-500' : 'w-3 bg-foreground-500/50 hover:bg-foreground-600'
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}